import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ERROR_PROVIDER } from '../../core/services/error.service';

export class RouteInjection {
	public readonly router = inject(Router);
	public readonly route = inject(ActivatedRoute);
	protected readonly errorService = inject(ERROR_PROVIDER);

	public resolveDataAsSignal<T>(key: string) {
		return toSignal(this.route.data.pipe(map((data) => data[key] as T)));
	}

	public resolveParamAsSignal<T>(key: string) {
		return toSignal(
			this.route.queryParamMap.pipe(
				map((params) => {
					const param = params.get(key);
					return param as unknown as T;
				}),
			),
		);
	}

	public resolveRouteParamAsSignal<T>(key: string) {
		if (!this.route.paramMap) {
			return toSignal(of(null as unknown as T));
		}
		return toSignal(this.route.paramMap.pipe(map((params) => params.get(key) as unknown as T)));
	}
}
